import { useCallback, useState } from 'react'
import type { GanttChartProps } from '../GanttChart.types'

type GanttArrow = NonNullable<GanttChartProps['props']['arrows']>[number]

const useGanttCardSelection = () => {
  const [selectedCardId, setSelectedCardId] = useState<string | null>(null)
  const [hoveredCardId, setHoveredCardId] = useState<string | null>(null)

  const toggleCardSelection = useCallback((cardId: string) => {
    setSelectedCardId((current) => (current === cardId ? null : cardId))
  }, [])

  const setHoveredCard = useCallback((cardId: string | null) => {
    setHoveredCardId(cardId)
  }, [])

  const isCardSelected = useCallback(
    (cardId: string) => selectedCardId === cardId,
    [selectedCardId]
  )

  const isArrowEmphasized = useCallback(
    (arrow: Pick<GanttArrow, 'fromCardId' | 'toCardId'>) =>
      selectedCardId === arrow.fromCardId ||
      selectedCardId === arrow.toCardId ||
      hoveredCardId === arrow.fromCardId ||
      hoveredCardId === arrow.toCardId,
    [selectedCardId, hoveredCardId]
  )

  return {
    toggleCardSelection,
    setHoveredCard,
    isCardSelected,
    isArrowEmphasized
  }
}

export default useGanttCardSelection
